/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventResponseRecordsInnerEventActivated } from './EventResponseRecordsInnerEventActivated';
import {
    EventResponseRecordsInnerEventActivatedFromJSON,
    EventResponseRecordsInnerEventActivatedFromJSONTyped,
    EventResponseRecordsInnerEventActivatedToJSON,
} from './EventResponseRecordsInnerEventActivated';
import type { EventResponseRecordsInnerEventShip } from './EventResponseRecordsInnerEventShip';
import {
    EventResponseRecordsInnerEventShipFromJSON,
    EventResponseRecordsInnerEventShipFromJSONTyped,
    EventResponseRecordsInnerEventShipToJSON,
} from './EventResponseRecordsInnerEventShip';

/**
 * 
 * @export
 * @interface EventResponseRecordsInnerEvent
 */
export interface EventResponseRecordsInnerEvent {
    /**
     * 
     * @type {EventResponseRecordsInnerEventActivated}
     * @memberof EventResponseRecordsInnerEvent
     */
    activated?: EventResponseRecordsInnerEventActivated;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEvent
     */
    dataSourceType?: string;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEvent
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEvent
     */
    severity?: string;
    /**
     * 
     * @type {EventResponseRecordsInnerEventShip}
     * @memberof EventResponseRecordsInnerEvent
     */
    ship?: EventResponseRecordsInnerEventShip;
}

/**
 * Check if a given object implements the EventResponseRecordsInnerEvent interface.
 */
export function instanceOfEventResponseRecordsInnerEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventResponseRecordsInnerEventFromJSON(json: any): EventResponseRecordsInnerEvent {
    return EventResponseRecordsInnerEventFromJSONTyped(json, false);
}

export function EventResponseRecordsInnerEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventResponseRecordsInnerEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activated': !exists(json, 'activated') ? undefined : EventResponseRecordsInnerEventActivatedFromJSON(json['activated']),
        'dataSourceType': !exists(json, 'data_source_type') ? undefined : json['data_source_type'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
        'ship': !exists(json, 'ship') ? undefined : EventResponseRecordsInnerEventShipFromJSON(json['ship']),
    };
}

export function EventResponseRecordsInnerEventToJSON(value?: EventResponseRecordsInnerEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activated': EventResponseRecordsInnerEventActivatedToJSON(value.activated),
        'data_source_type': value.dataSourceType,
        'id': value.id,
        'severity': value.severity,
        'ship': EventResponseRecordsInnerEventShipToJSON(value.ship),
    };
}

